// extracted by mini-css-extract-plugin
export var header = "_aj-0";